import React, { FC } from 'react';
import { Button as ReactBootstrapButton } from 'react-bootstrap';

export type ButtonVariant =
  | 'primary'
  | 'secondary'
  | 'success'
  | 'warning'
  | 'danger'
  | 'info'
  | 'light'
  | 'dark'
  | 'link';

interface ButtonProps extends React.ComponentPropsWithoutRef<'button'> {
  variant?: ButtonVariant;
  disabled?: boolean;
}

const Button: FC<ButtonProps> = ({
  variant = 'dark',
  disabled = false,
  children,
  ...props
}) => {
  return (
    <div>
      <ReactBootstrapButton variant={variant} disabled={disabled} {...props}>
        {children}
      </ReactBootstrapButton>
    </div>
  );
};

export default Button;
